module.exports = __webpack_public_path__ + "static/media/light-polution.8f77c6aa.jpg";